export default "__VITE_ASSET__45be2749__"